import { CONTENT_GROUP_DELETE } from "../constants";

const initialState = {
    isOpen: false,
    content_group_id: null,
    workspace_id: null,
};

export function card_delete_popup(state = initialState, action) {
    switch (action.type) {
        case CONTENT_GROUP_DELETE.OPEN_CARD_DELETE_MODAL:
            const { workspace_id, content_group_id } = action.payload;

            return { 
                        ...state, 
                        isOpen: true, 
                        content_group_id, 
                        workspace_id,
                    };
        case CONTENT_GROUP_DELETE.CLOSE_CARD_DELETE_MODAL:
            return initialState;
        default:
            return state;
    }
}